<template>
    <div>
        <attachment-uploader v-model="item.image" :canUpload="true" label="Immagine"></attachment-uploader>
        <div class="row mb-2 mt-2">
            <div class="col-6">
                <label class="form-label small">Larghezza (px)</label>
                <input class="form-control form-control-sm" type="number" min="1" v-model.number="item.width" />
            </div>
            <div class="col-6">
                <label class="form-label small">Altezza (px)</label>
                <input class="form-control form-control-sm" type="number" min="1" v-model.number="item.height" />
            </div>
        </div>
        <div class="mb-2" v-if="item.image && item.image.publicUrl">
            <button class="btn btn-sm btn-outline-secondary w-100 mb-1" @click="fitToImageSize">
                Adatta alle dimensioni originali
            </button>
            <button class="btn btn-sm btn-outline-secondary w-100" @click="fitToProportions">
                Adatta mantenendo proporzioni
            </button>
        </div>
        <div class="mb-2">
            <label class="form-label small">Adattamento</label>
            <select class="form-select form-select-sm" v-model="item.objectFit">
                <option value="contain">Contain</option>
                <option value="cover">Cover</option>
                <option value="fill">Fill</option>
                <option value="scale-down">Scale Down</option>
            </select>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as OM from '@/model';

@Options({})
export default class ImageDataConfigEditor extends Vue {
    @Prop() item: OM.ImageDataConfig;

    fitToImageSize() {
        const img = new Image();
        img.onload = () => { this.item.width = img.naturalWidth; this.item.height = img.naturalHeight; };
        img.src = this.item.image.publicUrl;
    }

    fitToProportions() {
        const img = new Image();
        img.onload = () => {
            const ratio = img.naturalWidth / img.naturalHeight;
            if (img.naturalWidth >= img.naturalHeight) {
                this.item.height = Math.round((this.item.width || 150) / ratio);
            } else {
                this.item.width = Math.round((this.item.height || 150) * ratio);
            }
        };
        img.src = this.item.image.publicUrl;
    }
}
</script>
